import { fetch } from '../utils/request';

const BASE_URL = process.env.STORY_API;

export default {
  loadFeaturedPosts(tagboardId, count, before) {
    let url = `${BASE_URL}/posts/${tagboardId}?count=${count}`;
    if (before) { url += `&before=${before}`; }

    return fetch(url);
  },

  getManyPosts(owner, posts) {
    return fetch(`${BASE_URL}/owner/${owner}/many`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ posts }),
    });
  },
};
